import ElementContentTimeline from '@/components/sections/builder/elements/body/timeline/content';
import ElementSettingTimeline from '@/components/sections/builder/elements/body/timeline/setting';
import TimelineContent from '@/components/sections/builder/elements/body/timeline/timeline-content';
import TimelineTitle from '@/components/sections/builder/elements/body/timeline/title';
import { TimelineElementDataType } from '@/components/sections/builder/elements/body/timeline/types';
import { GalleryVertical } from 'lucide-react';

const defaultData: TimelineElementDataType = {
  name: 'Timeline',
  layout: 'full',
  contentAlign: 'left',
  imagePosition: 'right',
  mobileMinWidth: 720,
};

const ElementPreviewIcon = GalleryVertical;

const Timeline = {
  type: 'timeline',
  group: 'body',
  defaultData,
  Element: ElementContentTimeline,
  Setting: ElementSettingTimeline,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [TimelineTitle, TimelineContent],
  childs: [TimelineTitle, TimelineContent],
};

export default Timeline;
